export default "__VITE_ASSET__2otVjFxz__"